import GalleryForm from "./galleryForm.container";

export default GalleryForm;
